import React, { useState } from 'react';
import '../custom.css';
import { Document, Page } from 'react-pdf'
import { GrClose } from 'react-icons/gr';
import i18n from 'i18next';

const AdditionalInfoPopup = (props) => {
    const [numPages, setNumPages] = useState(0);

    return (
        <div className='popup'>
            <div className='popup-open-agreement d-flex flex-column'>
                <div className="d-flex flex-row justify-content-between" style={{ marginBottom: "30px" }}>
                    <div className="popup-header">
                    {i18n.t('additional info')}
                    </div>
                    <div className="popup-close-icon-wrapper d-flex">
                        <GrClose role="button" onClick={props.closePopup} />
                    </div>
                </div>

                <div className="popup-content d-flex flex-column">
                    <Document
                        file={`data:application/pdf;base64,${props.info}`}
                        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                    >
                        {Array.from({ length: numPages }, (_, index) => (
                            <Page
                                key={index + 1}
                                pageNumber={index + 1}
                                width={1100}
                                renderTextLayer={false}
                                renderAnnotationLayer={false}
                            />
                        ))}
                    </Document>
                </div>
            </div>
        </div>
    );
}

export default AdditionalInfoPopup;